
const getStoreBearer = () => {
  let auth = window.localStorage.getItem('sellsuki.store.bearer')
  return auth
}

const getSellsukiUser = () => {
  let user = window.localStorage.getItem('sellsuki.user')
  user = JSON.parse(user)
  return user
}

const getUser = () => {
  let user = window.localStorage.getItem('sellsuki.user')
  user = JSON.parse(user)
  const result = {
    id: user.user.id ? user.user.id : '',
    first_name: user.user.first_name ? user.user.first_name : '',
    last_name: user.user.last_name ? user.user.last_name : ''
  }
  return result
}
function getUserCashier () {
  let user = window.localStorage.getItem('sellsuki.user')
  user = JSON.parse(user)
  const result = {
    id: user.user.id ? parseInt(user.user.id) : 0,
    name: user.user.first_name ? `${user.user.first_name} ${user.user.last_name}` : '',
    email: user.user.email ? user.user.email : ''
  }
  return result
}

const getBranchID = () => {
  let results = window.localStorage.getItem('currentBranchPOS')
  return JSON.parse(results).branch_id
}
const getUnitID = () => {
  let results = window.localStorage.getItem('currentBranchPOS')
  return JSON.parse(results).unit_id
}
const getPOSID = () => {
  let results = window.localStorage.getItem('currentBranchPOS')
  return JSON.parse(results).pos_id
}
const getWerehouse = () => {
  let results = window.localStorage.getItem('currentBranchPOS')
  return JSON.parse(results) ? JSON.parse(results).warehouse : ''
}
const getBranchName = () => {
  let results = window.localStorage.getItem('currentBranchPOS')
  return results ? JSON.parse(results).name : ''
}
const getCurrentBranchPOS = () => {
  let getItem = window.localStorage.getItem('currentBranchPOS')
  const result = getItem ? JSON.parse(getItem) : ''
  return result
}

const getStoreId = () => {
  let getItem = window.localStorage.getItem('currentBranchPOS')
  const result = getItem ? JSON.parse(getItem).store_id : '000000000'
  return result
}
export {
  getStoreBearer,
  getUser,
  getBranchID,
  getUnitID,
  getUserCashier,
  getPOSID,
  getWerehouse,
  getBranchName,
  getSellsukiUser,
  getCurrentBranchPOS,
  getStoreId
}



// WEBPACK FOOTER //
// ./src/utils/helper/localStorage.js